module.exports = __webpack_public_path__ + "img/AndrewGray@2x.5b8a85be.png";